export default "__VITE_ASSET__7251087d__"